// extracted by mini-css-extract-plugin
export default {"select-object-modal":"selectObjectModal_select-object-modal__Vezun","footer":"selectObjectModal_footer__cKV7x"};